import React from "react";
import Radium from "radium";

const HOVER_ZOOM_STYLE = {
  cursor: "pointer",
  transition: "0.1s all ease-in-out",
  ":hover": {
    transform: "scale(1.05)"
  }
};

const INNER_HOVER_ONLY_STYLE = {
  transform: "scale(0.9)",
  transition: "0.1s all ease-in-out",
  opacity: 0
};

const INNER_HOVER_SHOWN = {
  transform: "scale(1)",
  opacity: 1
};

const BACKGROUND_IMAGE_STYLE = {
  backgroundPosition: "center center",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  height: 300
};

class FilmPoster extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static contextTypes = {
    isLarge: React.PropTypes.bool,
    tenant: React.PropTypes.object
  };

  render() {
    let {
      src,
      backgroundSrc,
      style,
      showInnerOnHover,
      forceHover,
      children
    } = this.props,
      { isLarge, tenant } = this.context;

    if (tenant.film_guide_always_show_titles) {
      showInnerOnHover = false;
    }

    return (
      <div
        key="poster"
        className="parallax rounded"
        style={[
          HOVER_ZOOM_STYLE,
          forceHover && HOVER_ZOOM_STYLE[":hover"],
          style
        ]}
      >
        <div className="parallax-top-left"></div>
        <div className="parallax-top-right"></div>
        <div className="parallax-bottom-left"></div>
        <div className="parallax-bottom-right"></div>
        <div
          className="parallax-content rounded"
          style={{
            height: "100%",
            backgroundColor: "#ccc",
            zIndex: 101,
            position: 'relative',
            pointerEvents: 'none'
          }}
        >
          <div
            key="front"
            className="parallax-front"
            style={
              isLarge && showInnerOnHover
                ? [
                  INNER_HOVER_ONLY_STYLE,
                  Radium.getState(this.state, "poster", ":hover") &&
                  INNER_HOVER_SHOWN
                ]
                : null
            }
          >
            {children}
          </div>
          <div className="parallax-back">
            {backgroundSrc ? (
              <div
                className="rounded"
                style={[
                  BACKGROUND_IMAGE_STYLE,
                  { backgroundImage: `url(${backgroundSrc})` },
                  style.height && { height: style.height }
                ]}
              />
            ) : (
                <img
                  src={src}
                  style={{ width: "100%" }}
                  className="img-responsive rounded"
                />
              )}
          </div>
        </div>
      </div>
    );
  }
}

export default Radium(FilmPoster);



// WEBPACK FOOTER //
// ./src/app/components/partials/film-poster.jsx